import { FormControlLabel, Switch, SwitchProps, styled } from "@mui/material";
import * as React from "react";

declare const window: any;

export default function ContactModalContainer({
  theme,
  colors,
  isContactModal,
  setIsContactModal,
  builderLogo,
  projectLogo,
  data,
  legalText,
  projectLogosMultiples,
  active_builder_logo,
  logo_invertido,
}: any) {
  React.useEffect(() => {
    const m_contact: any = document.querySelector(".contacto-modal");

    if (m_contact) {
      if (isContactModal) {
        m_contact.style.display = "grid";
      } else {
        setTimeout(() => {
          m_contact.style.display = "none";
        }, 510);
      }
    }
  }, [isContactModal]);

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  return (
    <div
      className={`contacto-modal ${theme} ${isContactModal ? "show" : ""} `}
      style={{ zIndex: isContactModal ? 10 : 0 }}
    >
      <div className="contacto-modal-close">
        <i
          className="fas fa-xmark"
          onClick={() => setIsContactModal(false)}
        ></i>
      </div>

      <div className="contacto-modal-row">
        <div
          className="contacto-modal-col-left"
          style={
            projectLogosMultiples?.length > 0
              ? {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }
              : {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }
          }
        >
          {/* Logo principal del proyecto */}
          {projectLogo ? (
            <img
              src={`${
                window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/"
              }${projectLogo}`}
              alt="Logo proyecto"
              style={
                projectLogosMultiples?.length > 0
                  ? { marginBottom: "0.75rem" }
                  : { height: "100px" }
              }
            />
          ) : null}

          {projectLogosMultiples?.length === 0 ? (
            // Caso SIN logos adicionales → proyecto + constructora al mismo nivel
            active_builder_logo ? (
              <img
                src={`${
                  window.hybrid
                    ? "./"
                    : "https://d1bsymnertnea6.cloudfront.net/"
                }${builderLogo}`}
                alt="Logo constructora"
                style={{ height: "100px" }}
              />
            ) : null
          ) : (
            // Caso CON 1 o más logos adicionales
            <div
              className={`contacto-modal-col-left-multiples count-${
                projectLogosMultiples?.length + (active_builder_logo ? 1 : 0)
              }`}
            >
              {/* Logo constructora */}
              {active_builder_logo ? (
                <img
                  src={`${
                    window.hybrid
                      ? "./"
                      : "https://d1bsymnertnea6.cloudfront.net/"
                  }${builderLogo}`}
                  alt="Logo constructora"
                />
              ) : null}

              {/* Logos adicionales (ordenados) */}
              {projectLogosMultiples
                ?.slice()
                .sort((a: any, b: any) => a.indice - b.indice)
                .map((item: any, i: number) => (
                  <img
                    key={i}
                    src={`${
                      window.hybrid
                        ? "./"
                        : "https://d1bsymnertnea6.cloudfront.net/"
                    }${item.link}`}
                    alt={`Logo adicional ${i + 1}`}
                  />
                ))}
            </div>
          )}
        </div>

        <div className="contacto-modal-col-right">
          {data.map((e) => (
            <>
              <div className="contacto-modal-col-right-title">{e.name}</div>
              <div className="contacto-modal-col-right-location">
                <img src="./UI/contacto/location.svg" alt="" />
                {e.location}
              </div>
              <div className="contacto-modal-col-right-horarios">
                <strong>Horario de atención</strong>
                {e.hours.map((h) => (
                  <>
                    <div>{h.dias}</div>
                    <div>
                      {h.hour_from} {h.hour_to}
                    </div>
                  </>
                ))}
              </div>
              {e.emails.length > 0 ? (
                <div className="contacto-modal-col-right-email">
                  <div className="contacto-modal-col-right-email-sub">
                    <img src="./UI/contacto/mail.svg" alt="" />
                    <strong>Correos Electrónicos</strong>
                  </div>
                  {e.emails.map((h) => (
                    <div> {h.email}</div>
                  ))}
                </div>
              ) : null}
              <div className="contacto-modal-col-right-map">
                <img src="./UI/contacto/map.svg" alt="" />
                <a
                  href={e.URLMaps}
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = darkenColor(
                      colors?.main_buttons,
                      0
                    );
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = "";
                  }}
                >
                  Planea cómo llegar - <strong>Google Maps</strong>
                </a>
              </div>
              <div className="contacto-modal-col-right-map">
                <img src="./UI/contacto/waze.svg" alt="" />
                <a
                  href={e.URLWaze}
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = darkenColor(
                      colors?.main_buttons,
                      0
                    );
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = "";
                  }}
                >
                  Planea cómo llegar - <strong>Waze</strong>
                </a>
              </div>
              {e.phones.length > 0 ? (
                <div className="contacto-modal-col-right-phone">
                  <div className="contacto-modal-col-right-phone-sub">
                    <img src="./UI/contacto/phone.svg" alt="" />
                    <strong>Teléfonos</strong>
                  </div>
                  {e.phones.map((h) => (
                    <div> {h.number}</div>
                  ))}
                </div>
              ) : null}
              {e.phones.length > 0 ? (
                <div className="contacto-modal-col-right-phone">
                  <div className="contacto-modal-col-right-phone-sub">
                    <img src="./UI/contacto/wp.svg" alt="" />
                    <strong>Whatsapp</strong>
                  </div>
                  {e.phones.map((h) => {
                    return h?.whatsapp === "true" ? (
                      <a
                        href={`https://wa.me/${h.number}?text=Hello,%20I%20am%20interested%20in%20your%20services`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onMouseOver={(e) => {
                          e.currentTarget.style.color = darkenColor(
                            colors?.main_buttons,
                            0
                          );
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.color = "";
                        }}
                      >
                        {h.number}
                      </a>
                    ) : null;
                  })}
                </div>
              ) : null}
            </>
          ))}

          {/* <div style={{ color: "#fff", padding: "10px" }}>{legalText}</div> */}
        </div>
      </div>
    </div>
  );
}
